import {jsonToFromData, fnGetCodeVal} from '~/utils/admin-common'
import {code} from '~/static/code.json'
import {i18n} from '~/plugins/i18n'

function resetRemainingAppFilter (state, payload) {
  if (_.get(payload, 'cancel')) state.remainingAppFilter = _.cloneDeep(state.fetchedAppFilter) // 애플리케이션  팝업에서 호출시 모든 애플리케이션이 선택 되지 않은 필터로 이동
  else state.remainingAppFilter = []
  state.selectedAppFilter = []
}
function settingRemainingAppFilter (state, payload) {
  const action = _.get(payload, 'action')
  /** 1. cloneTargetData */
  const payloadSize = !_.isEmpty(payload.data) ? _.size(payload.data) : 0
  const tempData = (action === 'recover') ? _.cloneDeep(state.fetchedAppFilter) : _.cloneDeep(state.remainingAppFilter)
  let foundCnt = 0
  let copy, remainingLength
  function whileChangeFn (cpSize) {
    const remainData = tempData[remainingLength]
    if (_.isNil(remainData)) return false
    _.forEach(payload.data, (targetData) => {
      const key = _.has(targetData, 'val') ? 'val' : 'app_obj_id'
      const targetId = targetData[key]
      if (remainData.app_obj_id !== targetId) return
      // A. ADD reference index of the original array
      remainData.originalIdx = remainingLength
      // B. Pushing operation in optimized way
      if (action === 'edit') copy[foundCnt] = remainData
      else copy[copy.length - payloadSize + foundCnt] = remainData
      /* 추후 destructive method vs newArray creation (PERFORMANCE CHECK) */
      tempData.splice(remainingLength, 1)
      foundCnt += 1
      return false
    })
    if (foundCnt > 0 && cpSize === foundCnt) return true
  }
  function whileRemoveFn () {
    // copy: selectedItems, payload.data: removeTargetItems
    const remainData = copy[remainingLength]
    if (_.isNil(remainData)) return false
    _.forEach(payload.data, (targetData) => {
      if (remainData.app_obj_id !== targetData.app_obj_id) return
      // A. get OriginalIdx reference (if missing, set to index to 0)
      const originalIdx = _.get(targetData, 'originalIdx') || 0
      const targetItem = _.cloneDeep(targetData)
      copy.splice(remainingLength, 1)
      tempData.splice(originalIdx, 0, targetItem)
      foundCnt += 1
      return false
    })
    if (foundCnt > 0 && payloadSize === foundCnt) return true
  }
  // add - 애플리케이션 팝업에서 호출(+data), recover - 애플리케이션 팝업에서 호출(+data), edit - 직접정책 신청 팝업에서 호출(+data)
  if (['add', 'edit', 'recover'].indexOf(action) > -1) {
    let copySize = 0
    if (action === 'edit') {
      state.selectedAppFilter = _.cloneDeep(payload.data)
      copy = _.cloneDeep(payload.data)
    } else { copy = _.cloneDeep(state.selectedAppFilter) } // add, recover 일때
    copySize = _.size(copy)
    /** 2. set array length first (avoid memory allocation) */
    if (action === 'recover') copy.length = copySize
    else copy.length = _.size(state.selectedAppFilter) > 0 ? copySize + payloadSize : payloadSize // add, edit 일때
    // recover 일때 모든 애플 리스트, 아닐때 선택되지 않은 애플 리스트
    remainingLength = _.size(tempData)

    while (remainingLength--) {
      const isBreak = whileChangeFn(copySize)
      if (isBreak) break
    }
  } else {
    /** remove - 애플리케이션 팝업에서 호출(+data) */
    copy = _.cloneDeep(state.selectedAppFilter)
    remainingLength = _.size(copy)
    while (remainingLength--) {
      const isBreak = whileRemoveFn()
      if (isBreak) break
    }
  }
  return { copy, tempData }
}
export const state = () => ({
  codes: code,
  apiUrl: {
    payAprvalUnameUrl: '/api/pm/pay-aprval/uname', // 결재설정 문구조회
    pamsReqFixUrl: '/api/pm/pams-req/fix', // pams 신청 정책 조회
    pamsReqUrl: '/api/pm/pams-req', // pams 신청 정책
    pamsReqCancelUrl: '/api/pm/pams-req/cancel', // 초기화 처리
    pamsReqAttachUrl: '/api/pm/pams-req/attach', // 신청 정책 파일
    pamsReqAprvalUrl: '/api/pm/pams-req/aprval', // pams 신청 정책 결제
    pamsReqUnameUrl: '/api/pm/pams-req/uname', // 신청 외부 이름 중복확인
    pamsReqDateUrl: '/api/pm/pams-req/date', // 신청 사용기간 수정
    pamsReqRuleUrl: '/api/pm/pams-req/rule', // pams 신청 정책 상세 조회
    pamsFixRuleUrl: '/api/pm/pams-fix/rule', // pams 상세 신청 항목추가
    pamsFixRuleMultiUrl: '/api/pm/pams-fix/rule/multi', // pams 상세 신청 항목 삭제
    pamsFixRuleCopyUrl: '/api/pm/pams-fix/rule/copy', // pams 상세 신청 복사
    pasmFixRuleBannetUrl: '/api/pm/pams-fix/rule/bannet', // pams 신청항목 금지네트워크 해제
    intNetUrl: '/api/pm/int-net', // 내부 네트워크 조회
    intNetUnameUrl: '/api/pm/int-net/uname', // 내부 네트워크 이름 중복확인
    netRuleUrl: '/api/pm/net-rule', // pams 방화벽 매칭 규칙
    netRuleUnameUrl: '/api/pm/net-rule/uname', // pams 방화벽 매칭 규칙 이름 중복 확인
    pamsReqStatusUrl: '/api/pm/pams-req/status', // 신청 상태 유형 수정
    pamsReqRejectUrl: '/api/pm/pams-req/reject', // 신청 상태 반려
    pamsFixExcelUrl: '/api/pm/pams-fix/excel', // pams 상세 신청 추가 엑셀 양식 업로드
    pamsFixAssignUrl: '/api/pm/pams-fix/assign', // pamsFixAssign
    pamsFixApplyUrl: '/api/pm/pams-fix/apply', // 신청 정책 마법사 적용
    pamsSaveRollback: '/api/pm/pams-req/saverollback', // Savepoint/Rollback
    appObjUrl: '/api/op/app/simple/objects'
  },
  requestInquiryStep: 0,
  requestInquiryData: [], // 신청정보 리스트
  requestInquiryDataFilter: [],
  requestInquiryInfoData: {}, // 신청정보 상세 기본
  requestInquiryFormData: {},
  requestInquiryAprvInfo: [], // 결제정보
  requestInquiryRuleData: [], // 상세 신청 정보 rule
  requestInquiryFwRuleData: [], // 상세 방화벽 rule
  requestProtocol: [],
  requestRuleResult: null, // 신청상세내역처리결과
  requestResult: null,
  requestFixResult: null,
  requestExcelUploadResult: null,
  requestInqueryDirectResult: null,
  requestInqueryCancelResult: null,
  pamsFixExcelUploadConfirmResult: null,
  requestInqueryDirectConfirmResult: null,
  pamsFixAssignDeviceResult: null,
  policiesPosistionResult: null,
  policiesApplicationList: [],
  pamsFixAssignDeviceList: [],
  policiesFirewallList: [],
  policiesPosistionList: [],
  policiesRuleList: [],
  policiesOptimizationList: [],
  errorMessage: null,
  /** 배치입력 파일 업로드 */
  upLoadFile: void 0,
  /** 어플리케이션 필터 **/
  fetchedAppFilter: [], // 전체 리스트
  remainingAppFilter: [], // 선택 되지 않은 필터
  selectedAppFilter: [], // 선택 된 필터
  appFilterDataSet: [] // 실제 설정된 App 필터 값
})
export const mutations = {
  mutationErrorMessage (state, payload) {
    state.errorMessage = ''
    state.errorMessage = payload
  },
  mutRequestInquiryList (state, payload) {
    state.requestInquiryData = payload.filter((item) => {
      item.chk = false
      item.pams_req_status_type_name = fnGetCodeVal('pams_req_status_type', item.pams_req_status_type)
      item.pams_req_type_name = fnGetCodeVal('pams_req_type', item.pams_req_type)
      item.pams_req_attch_file = item.attch_cnt > 0 ? 'O' : ''
      item.pams_fix_rule_verify_types = []
      if (typeof item.pams_fix_rule_verify_type === 'string') {
        item.pams_fix_rule_verify_types = item.pams_fix_rule_verify_type.split(',').map(typeCode => {
          return {
            pams_fix_rule_verify_type: parseInt(typeCode),
            pams_fix_rule_verify_type_name: fnGetCodeVal('pams_fix_rule_verify_type', parseInt(typeCode))
          }
        }).filter(item => { return item.pams_fix_rule_verify_type !== 1 })
      }
      return item
    })
    state.requestInquiryDataFilter = state.requestInquiryData
  },
  // 직접 정책 신청 추가.
  mutPostRequestInqueryDirect (state, payload) {
    state.requestInqueryDirectResult = payload
    state.requestInquiryFormData = _.clone(state.requestInquiryFormData)
    state.requestInquiryFormData.pams_req_id = parseInt(payload.result.msg)
    state.requestInquiryInfoData.pams_req_status_type = 0
    state.requestInquiryInfoData = _.clone(state.requestInquiryInfoData)
  },
  // 직접 정책 신청 수정.
  mutPutRequestInqueryDirect (state, payload) { state.requestInqueryDirectResult = payload },
  // 직접 정책 취소
  mutPutRequestInqueryCancel (state, payload) { state.requestInqueryCancelResult = payload },
  mutRequestInqueryDirectConfirm (state, payload) { state.requestInqueryDirectConfirmResult = payload },
  // 정책 자동 관리 > 상세 신청 정보 (기본정보)
  mutRequestInquiryInfo (state, payload) {
    if (payload.length > 0) {
      state.requestInquiryInfoData = payload.map(item => {
        item.pams_req_status_type_name = fnGetCodeVal('pams_req_status_type', item.pams_req_status_type)
        item.pams_req_type_name = fnGetCodeVal('pams_req_type', item.pams_req_type)
        return item
      })[0]
    }
  },
  mutRequestInquiryAprvInfo (state, payload) { state.requestInquiryAprvInfo = payload },
  // pams 신청 상태 유형 수정
  mutPutRequestInquiryStatus (state, payload) { state.requestResult = payload.result.msg },
  /** 신청항목 리스트 (RequestRule), 확정 신청 정보 */
  mutRequestInquiryRule (state, payload) {
    state.requestInquiryRuleData = payload.map((item, index) => {
      item.idx = (index + 1)
      item.pams_fix_rule_verify_type_name = fnGetCodeVal('pams_fix_rule_verify_type', item.pams_fix_rule_verify_type)
      item.pams_fix_rule_prtc_name = fnGetCodeVal('net_srv_prtc', item.pams_fix_rule_prtc)
      item.pams_rule_type_name = fnGetCodeVal('pams_fix_rule_type', item.pams_fix_rule_type)
      if (typeof item.pams_assign_info_id !== 'undefined') {
        item['pams_assign'] = item.pams_assign_info_id ? 1 : 0
      }
      return item
    })
  },
  /** acsPostRequestInquiryRule >>>> 신청항목 추가 : request rule add
   * 원본 0 : 최초 신청 내용
   * 신규 1 : “추가”를 통해 입력된 내용
   * 수정 2 : 원본을 “수정”을 통해 수정한 내용
   * 삭제 3 : 원본/수정에서 PAMS 시스템 또는 관리자의 판단으로 해당 Row를 반영하지 않기로 결정한 내용
   */
  resetAppFilter (state) {
    state.fetchedAppFilter = []
    state.remainingAppFilter = []
    state.selectedAppFilter = []
    state.appFilterDataSet = []
  },
  setAppData (state, payload) { state.appFilterDataSet = _.cloneDeep(payload) },
  mutPostRequestInquiryRule (state, payload) { state.requestRuleResult = payload },
  mutPamsFixExcelUploadConfirm () {},
  mutRequestInquiryFormDataInit (state) { state.requestInquiryFormData = {} },
  mutRequestInquiryInfoDataReset (state) { state.requestInquiryInfoData = {} },
  mutPutRequestInquiryDateChange (state, payload) {
    const startDate = payload.pams_req_start_date === '' ? null : payload.pams_req_start_date,
      endDate = payload.pams_req_end_date === '' ? null : payload.pams_req_end_date
    // 상세보기 - Info Data
    const requestInquiryInfoData = _.cloneDeep(state.requestInquiryInfoData)
    requestInquiryInfoData.pams_req_start_date = startDate
    requestInquiryInfoData.pams_req_end_date = endDate
    state.requestInquiryInfoData = requestInquiryInfoData
    // 직접 신청 - Form Data
    const requestInquiryFormData = _.cloneDeep(state.requestInquiryFormData)
    requestInquiryFormData.pams_req_start_date = startDate
    requestInquiryFormData.pams_req_end_date = endDate
    state.requestInquiryFormData = requestInquiryFormData
  },
  mutPamsFixExcelUpload (state, payload) {
    if (payload.result.list !== undefined) {
      payload.result.list = payload.result.list.map((item, index) => {
        item.idx = index
        item.pams_fix_rule_verify_type_name = fnGetCodeVal('pams_fix_rule_verify_type', item.pams_fix_rule_verify_type)
        item.pams_fix_rule_prtc_name = fnGetCodeVal('net_srv_prtc', item.pams_fix_rule_prtc)
        item.pams_fix_rule_type_name = fnGetCodeVal('pams_fix_rule_type', item.pams_fix_rule_type)
        return item
      })
    }
    state.requestExcelUploadResult = payload
  },
  // 신청 적책 일괄할정
  acsPutPasmRequestFix (state, payload) { state.requestFixResult = payload },
  acsPamsFixAssignDevice (state, payload) { state.pamsFixAssignDeviceList = payload },
  mutDeletePamsFixAssignDevice (state, payload) {
    state.pamsFixAssignDeviceResult = null
    state.pamsFixAssignDeviceResult = payload
  },
  // 정책 적용 마법사 신청단계 적용 id 목록
  mutPoliciesApplicationAssign (state, payload) { state.policiesApplicationAssign = { pams_req_id_list: payload.map(item => { return item.pams_req_id }) } },
  // 정책 적용 마법사 신청단계 조회
  mutPoliciesApplicationList (state, payload) {
    const policiesApplicationList = []
    payload.forEach(item => {
      const obj = item.pams_req
      obj['pams_req_usr_info'] = `${obj.pams_req_usr_name}/${obj.pams_req_rank_name}/${obj.pams_req_depart_name}`
      obj['assign_device'] = item.assign_device
      policiesApplicationList.push(obj)
    })
    state.policiesApplicationList = Object.freeze(policiesApplicationList)
  },
  mutCancelPoliciesApplicationList (state, payload) { state.requestFixResult = payload },
  // 정책정용 마법사 적용
  mutPoliciesApplicationApply (state, payload) { state.requestFixResult = payload },
  mutPoliciesApplicationFirewall (state, payload) {
    const policiesFirewallList = []
    _.forEach(payload, row => {
      const device = row.device
      _.forEach(row.pams_req, req => {
        policiesFirewallList.push({ ...device, ...req })
      })
    })
    state.policiesFirewallList = policiesFirewallList
  },
  mutPoliciesApplicationFirewallPosList (state, payload) { // 테이블용
    state.policiesPosistionList = payload.map(item => {
      item.srv = item.srv.map(sItem => {
        sItem['pams_assign_rule_srv_prtc_name'] = fnGetCodeVal('net_srv_prtc', sItem.pams_assign_rule_srv_prtc)
        return sItem
      })
      return item
    })
  },
  mutPostPoliciesApplicationFirewallPosition (state, payload) {
    const Max = state.policiesPosistionList.length
    state.policiesPosistionResult = payload.source
    const ruleSeq = payload.source.pams_assign_rule_seq
    const ruleSeqOrg = payload.source.org_seq
    const ruleObjRow = state.policiesPosistionList[ruleSeqOrg]
    if (ruleSeqOrg !== Max) {
      state.policiesPosistionList.splice(ruleSeqOrg, 1)
      state.policiesPosistionList.splice(ruleSeq, 0, ruleObjRow)
    }
  },
  acsPoliciesApplicationRuleList (state, payload) {
    state.policiesRuleList = payload.filter(item => {
      item.pams_fix_rule_prtc_name = fnGetCodeVal('net_srv_prtc', item.pams_fix_rule_prtc)
      return item
    })
  },
  acsPoliciesApplicationOptimization (state, payload) {
    state.policiesOptimizationList = payload.filter(item => {
      item.srv = item.srv.filter(sItem => {
        sItem['pams_assign_rule_srv_prtc_name'] = fnGetCodeVal('net_srv_prtc', sItem.pams_assign_rule_srv_prtc)
        return sItem
      })
      return item
    })
  },
  // 파일 업로드
  fileUpload (state, {file}) { state.upLoadFile = file },
  clearRequestInquiryInfoData (state) { state.requestInquiryInfoData = {} },
  clearRequestInquiryRuleData (state) { state.requestInquiryRuleData = [] },
  clearRequestInquiryAprvInfo (state) { state.requestInquiryAprvInfo = [] },
  clearPamsFixAssignDeviceList (state) { state.pamsFixAssignDeviceList = [] },
  clearPoliciesOptimizationList (state) { state.policiesOptimizationList = [] },
  clearPoliciesApplicationList (state) {
    state.policiesApplicationList = []
    state.policiesFirewallList = []
  },
  clearPoliciesPosistionList (state) { state.policiesPosistionList = [] },
  setAppFilter (state, payload) {
    // sample dataFormat: { app_obj_id: 10074, app_obj_type: 0, app_type: 1, app_obj_name: "11st", app_obj_desc: "" }
    /** 1. SET fetchedAppFilter(entire list) */
    if (!_.get(payload, 'action')) state.fetchedAppFilter = payload.data
    /** action key가 있을 경우 */
    if (_.has(payload, 'action')) state.selectedAppFilter = _.cloneDeep(state.appFilterDataSet)
    /** 2. UPDATE remainingFilter => fetchedAppFilter - selectedAppFilter */
    const tempAllList = _.cloneDeep(payload.data)
    if (_.get(payload, 'resetFlag')) {
      /** 2-1. Reset selectedAppFilter */
      state.selectedAppFilter = []
      state.appFilterDataSet = []
      /** 3. SET remainingAppFilter */
      state.remainingAppFilter = tempAllList
      return
    }
    if (_.size(state.selectedAppFilter) === 0) {
      /** 3. SET remainingAppFilter */
      state.remainingAppFilter = tempAllList
      return
    }
    /** 2-2. filter out selected filter from the entire list */
    let foundCnt = 0
    let i = _.size(tempAllList)
    const selectedLength = _.size(state.selectedAppFilter)
    while (i--) {
      for (let j = 0; j < _.size(state.selectedAppFilter); j++) {
        if (state.selectedAppFilter[j].app_obj_id === tempAllList[i].app_obj_id) {
          tempAllList.splice(i, 1)
          foundCnt += 1
          break
        }
      }
      if (foundCnt > 0 && selectedLength === foundCnt) break
    }
    /** 3. SET remainingAppFilter */
    state.remainingAppFilter = tempAllList
  },
  /**
   * 추후 performance optimization => create own splice instead of using function call
   * payload.action: 'reset', 'add', 'edit', 'remove'
   * payload.data: [{
       app_obj_id: 10074,
       app_obj_type: 0,
       app_type: 1,
       app_obj_name: "11st",
       app_obj_desc: "",
       originalIdx: 0 => keeping original order at insertion/removal of selected items
   }]
   */
  setRemainingAppFilter (state, payload) {
    if (!_.isUndefined(payload.type) && payload.type === 'app') { // 애플리케이션 팝업에서 호출하는 경우만 따로 분기
      if (payload.action === 'reset') {
        state.remainingAppFilter = _.cloneDeep(state.fetchedAppFilter)
        state.selectedAppFilter = []
      }
      if (payload.action === 'add') {
        _.forEach(payload.data, (item) => {
          const delNum = _.findIndex(state.remainingAppFilter, ['app_obj_id', item.app_obj_id])
          state.remainingAppFilter.splice(delNum, 1)
          const num = _.findIndex(state.selectedAppFilter, ['app_obj_id', item.app_obj_id])
          if (num < 0) state.selectedAppFilter.push({app_obj_id: item.app_obj_id, app_obj_name: item.app_obj_name})
        })
      }
      if (payload.action === 'remove') {
        _.forEach(payload.data, (item) => {
          const num = _.findIndex(state.selectedAppFilter, ['app_obj_id', item.app_obj_id])
          state.selectedAppFilter.splice(num, 1)
          const addNum = _.findIndex(state.remainingAppFilter, ['app_obj_id', item.app_obj_id])
          if (addNum < 0) state.remainingAppFilter.push({app_obj_id: item.app_obj_id, app_obj_name: item.app_obj_name})
        })
      }
      return
    }
    const action = _.get(payload, 'action')
    /** reset - 애플리케이션 팝업에서 호출(+cancel), reset - 직접정책 신청 팝업에서 호출 >> 호출 안하게 변경 */
    if (action === 'reset') {
      resetRemainingAppFilter(state, payload)
    } else {
      const { copy, tempData } = settingRemainingAppFilter(state, payload)
      state.selectedAppFilter = copy
      state.remainingAppFilter = tempData
    }
  }
}

export const actions = {
  acsSetErrorMessage ({commit, state}, payload) {
    const result = {}
    result.error = payload
    commit('mutationErrorMessage', result)
  },
  // 정책 자동관리 > 신청정보
  async acsRequestInquiryList ({commit, state}) {
    try {
      const success = await this.$axios.$get(`${state.apiUrl.pamsReqFixUrl}`, {loading: false, successAlert: false})
      commit('mutRequestInquiryList', success.result)
      return success
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 상세보기 팝업(상세 신청 정보) > 신청 정보
  async acsRequestInquiryInfo ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      commit('clearRequestInquiryRuleData')
      commit('clearRequestInquiryInfoData')
      res = await this.$axios.$get(`${state.apiUrl.pamsReqUrl}/${payload.pams_req_id}`, { loading: false, successAlert: false })
      if (res.code === 'ok') commit('mutRequestInquiryInfo', res.result)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 직접 정책신청 추가
  async acsPostRequestInqueryDirect ({commit, state}, payload) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsReqUrl}`, payload, {loading: false, successAlert: false})
      if (res.code === 'ok') commit('mutPostRequestInqueryDirect', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 직접 정책신청 수정
  async acsPutRequestInqueryDirect ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsReqUrl}/${payload.pams_req_id}`, payload.req, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutPutRequestInqueryDirect', res)
        return true
      } else { commit('mutationErrorMessage', res.result.msg) }
    } catch (error) { commit('mutationErrorMessage', error) }
    return false
  },
  // 직접 신청 정책 취소
  async acsPutRequestInqueryCancel ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsReqUrl}/cancel/${payload}`)
      if (res.code === 'ok') commit('mutPutRequestInqueryCancel', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  async acsPutRequestInqueryDirectConfirm ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsReqUrl}/fix/${payload}`)
      if (res.code === 'ok') commit('mutRequestInqueryDirectConfirm', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 상세보기 팝업(상세 신청 정보) > 결제 정보
  async acsRequestInquiryAprvInfo ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      commit('clearRequestInquiryAprvInfo')
      res = await this.$axios.$get(`${state.apiUrl.pamsReqAprvalUrl}/${payload.pams_req_id}`, { loading: false, successAlert: false })
      if (res.code === 'ok') commit('mutRequestInquiryAprvInfo', res.result)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 신청 사용기간 수정
  async acsPutRequestInquiryDateChange ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsReqDateUrl}`, payload)
      if (res.code === 'ok') commit('mutPutRequestInquiryDateChange', payload) // update
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 신청 상태 확정
  async acsPutRequestInquiryApply ({commit, state}, payload) {
    try {
      const res = await this.$axios.$post(state.apiUrl.pamsReqFixUrl, payload, {loading: true, successAlert: false})
      if (res.code !== 'ok') { commit('mutationErrorMessage', res.result.msg) }
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 신청 상태 -> 반려
  async acsPutRequestInquiryReject ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(state.apiUrl.pamsReqRejectUrl, payload, {loading: true, successAlert: false})
      if (res.code === 'ok') return res
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 직접 신청 취소 처리 38p
  async acsDeletePamsReqCancelId ({commit, state}, payload) {
    try {
      const res = await this.$axios.$delete(`${state.apiUrl.pamsReqCancelUrl}/${payload.pams_req_id}`, { loading: true, successAlert: false })
      if (res.code === 'ok') {
        commit('mutPutRequestInquiryStatus', res)
        return res
      } else { commit('mutationErrorMessage', res.result.msg) }
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 상세보기 팝업(상세 신청 정보) > 신청 상세 내역 / 반려 상세 내역, 확정 신청 정보, 대상 방화벽 설정
  // 정책 적용 마법사 > 상세보기 팝업(상세 신청 정보) > 확정 신청 정보, 생성 정책 정보
  async acsRequestInquiryRule ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      commit('clearRequestInquiryRuleData')
      res = await this.$axios.$get(`${state.apiUrl.pamsReqRuleUrl}/${payload.pams_req_id}`, { loading: false, successAlert: false })
      if (res.code === 'ok') commit('mutRequestInquiryRule', res.result)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  /** DOING!!!! 신청항목 추가 (직접 정책 신청: 추가) */
  async acsPostRequestInquiryRule ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      // PAMS 상세 신청 항목 추가
      res = await this.$axios.$post(`${state.apiUrl.pamsFixRuleUrl}`, payload)
      if (res.code === 'ok') commit('mutPostRequestInquiryRule', res)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 신청 항목 수정
  async acsPutRequestInquiryRule ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      // PAMS 상세 신청 항목 추가
      res = await this.$axios.$put(`${state.apiUrl.pamsFixRuleUrl}`, payload)
      if (res.code === 'ok') commit('mutPostRequestInquiryRule', res)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 신청 항목 삭제
  async acsDeleteRequestInquiryRule ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixRuleMultiUrl}`, payload)
      if (res.code === 'ok') commit('mutPostRequestInquiryRule', res)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 신청 항목 초기화
  async acsInitRequestInquiryRule ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsReqCancelUrl}/${payload.pams_req_id}`, null, {successAlert: false})
      if (res.code === 'ok') {
        commit('mutPostRequestInquiryRule', res)
        return true
      } else { commit('mutationErrorMessage', res.result.msg) }
    } catch (error) { commit('mutationErrorMessage', error) }
    return false
  },
  // 신청 항목 복사
  async acsPostRequestInquiryRuleCopy ({commit, state}, payload) {
    const result = {error: null}
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixRuleCopyUrl}`, payload)
      if (res.code === 'ok') {
        commit('mutPostRequestInquiryRule', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async acsPutPamsFixRuleBannet ({commit, state}, payload) {
    const result = {error: null}
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pasmFixRuleBannetUrl}`, payload)
      if (res.code === 'ok') {
        commit('mutPostRequestInquiryRule', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async ascPamsFixExcelUpload ({commit, state}, payload) {
    const result = {error: null}
    try {
      const req = jsonToFromData(payload)
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixExcelUrl}`, req)
      if (res.code === 'ok') {
        commit('mutPamsFixExcelUpload', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async ascPamsFixExcelUploadConfirm ({commit, state}, payload) {
    const result = {error: null}
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixExcelUrl}`, payload)
      if (res.code === 'ok') {
        commit('mutPamsFixExcelUploadConfirm', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async acsPutPasmRequestFix ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsReqFixUrl}`, payload)
      if (res.code === 'ok') commit('acsPutPasmRequestFix', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // ------ 정책적용 마법사 ---------
  // pams 신청 정책 대상 방화벽 매핑전 취소
  async acsCancelPoliciesApplicationList ({commit, state}) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}`, state.policiesApplicationAssign)
      if (res.code === 'ok') commit('mutCancelPoliciesApplicationList', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 상세보기 팝업(상세 신청 정보) > 대상 방화벽 설정 (방화벽 장비별 정책 조회)
  async acsPamsFixAssignRuleId ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      commit('clearRequestInquiryRuleData')
      res = await this.$axios.$get(`${state.apiUrl.pamsFixAssignUrl}/device/${payload.pams_req_id}/${payload.device_id}`, {loading: false, successAlert: false})
      if (res.code === 'ok') commit('mutRequestInquiryRule', res.result)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 대상 방화벽 설정 > 대상 방화벽 장비 설정 팝업 > 룰 할당 처리 43p
  async acsPutPamsFixAssignDeviceRuleId ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/device/rule/${payload.pams_req_id}/${payload.device_id}/${payload.pams_fix_rule_id}`, {loading: false, successAlert: false})
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 대상 방화벽 설정 > 대상 방화벽 장비 설정 팝업 > 룰 할당 해제 처리 43p
  async acsDeletePamsFixAssignDeviceRuleId ({commit, state}, payload) {
    try {
      const res = await this.$axios.$delete(`${state.apiUrl.pamsFixAssignUrl}/device/unrule/${payload.pams_assign_info_id}`, {loading: false, successAlert: false})
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  async acsPutPamsFixAssignDeviceRuleAll ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/device/rule-all/${payload.pams_req_id}/${payload.device_id}`, {loading: false, successAlert: false})
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  async acsDeletePamsFixAssignDeviceRuleAll ({commit, state}, payload) {
    try {
      const res = await this.$axios.$delete(`${state.apiUrl.pamsFixAssignUrl}/device/rule-all/${payload.pams_req_id}/${payload.device_id}`, {loading: false, successAlert: false})
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // PAMS 신청 정책 결과 조회후 대상 방화벽 장비 삭제
  async acsDeletePamsFixAssignDevice ({commit, state}, payload) {
    try {
      const res = await this.$axios.$delete(`${state.apiUrl.pamsFixAssignUrl}/device/${payload.pams_req_id}/${payload.device_id}`)
      if (res.code === 'ok') commit('mutDeletePamsFixAssignDevice', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  async acsPostPamsFixAssignDevice ({commit, state}, payload) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixAssignUrl}/device`, payload)
      if (res.code === 'ok') commit('mutDeletePamsFixAssignDevice', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 상세보기 팝업(상세 신청 정보) > 대상 방화벽 설정 (대상 방화벽 장비 조회)
  async acsPamsFixAssignDevice ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    commit('clearPamsFixAssignDeviceList')
    try {
      res = await this.$axios.$get(`${state.apiUrl.pamsFixAssignUrl}/device/${payload.pams_req_id}`, { loading: false, successAlert: false })
      if (res.code === 'ok') commit('acsPamsFixAssignDevice', res.result)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 정책 적용 마법사 > 상세보기 팝업(상세 신청 정보) > 생성 정책 정보 (대상 방화벽 장비 조회)
  async acsPamsFixOptimizeDevice ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      commit('clearPamsFixAssignDeviceList')
      res = await this.$axios.$get(`${state.apiUrl.pamsFixAssignUrl}/rule/device/${payload.pams_req_id}`)
      if (res.code === 'ok') commit('acsPamsFixAssignDevice', res.result)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 결과 조회 > 적용 내역 > 확정 정책별 조회 57p
  async acsPamsReqResultId ({commit, state}, payload) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.pamsReqUrl}/result/${payload.pams_req_id}`, { loading: true, successAlert: false })
      commit('acsPamsFixAssignDevice', res.result)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 대상방화벽 확인 (post api 임시 제거) 신청처리 #1-1
  async acsPoliciesApplicationAssignStep1 ({commit, state}, payload) {
    try {
      const resLst = await this.$axios.$post(`${state.apiUrl.pamsFixAssignUrl}`, payload, { loading: false, successAlert: false })
      if (resLst.code === 'ok' && resLst.result.length > 0) {
        commit('mutPoliciesApplicationAssign', resLst.result)
        return resLst
      } else {
        if (_.isArray(resLst.result) && resLst.result.length <= 0) {
          resLst.code = 'fail'
          resLst.result = {}
          resLst.result.msg = i18n.t('msg.pams_no_assign_rule')
        }
        commit('mutationErrorMessage', resLst.result.msg)
        return resLst
      }
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 대상방화벽 조회 신청처리 #1-2
  async acsPoliciesApplicationListStep1List ({commit, state}) {
    try {
      const resLst = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}`, state.policiesApplicationAssign, { loading: false, successAlert: false })
      if (resLst.code === 'ok') {
        commit('mutPoliciesApplicationList', resLst.result)
        return resLst
      } else { commit('mutationErrorMessage', resLst.result.msg) }
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 신청 단계 취소
  async acsDeletePoliciesApplicationStep1 ({commit, state}) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/cancel`, state.policiesApplicationAssign, { loading: false, successAlert: false })
      if (res.code === 'ok') return res
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 신청 단계 > 대상 방화벽 설정 취소
  async acsDeletePamsFixAssignDeviceCancel ({commit, state}) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/device/cancel`, state.policiesApplicationAssign, { loading: false, successAlert: false })
      if (res.code === 'ok') commit('mutDeletePamsFixAssignDevice', res)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 생성/최적화 생성 > 신청 > 다음
  async acsPostPamsFixAssignCreate ({commit, state}) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixAssignUrl}/create`, state.policiesApplicationAssign, { loading: false, successAlert: false })
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 생성/최적화 조회 > 신청 > 다음
  async acsPamsFixAssignCreate ({commit, state}) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/create`, state.policiesApplicationAssign, { loading: false, successAlert: false })
      if (res.code === 'ok') commit('mutPoliciesApplicationList', res.result)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 적용 마법사 > 정책 최적화 이전 > PUT /api/pm/pams-fix/assign/create/priv
  async acsPutPamsFixAssignCreatePriv ({commit, dispatch, state}) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/create/priv`, state.policiesApplicationAssign, { loading: true, successAlert: false })
      if (res.code === 'ok') {
        dispatch('acsPamsFixAssignCreate')
        return res
      } else { commit('mutationErrorMessage', res.result.msg) }
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 적용 마법사 - 정책 적용 > 신청정보별 조회 48p
  async acsPostPamsFixAssignCreateApplyReq ({commit, state}) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixAssignUrl}/create/apply/req`, state.policiesApplicationAssign, { loading: false, successAlert: false })
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      else commit('mutPoliciesApplicationList', res.result)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 적용 마법사 - 정책 적용 > 방화벽별 조회 50p
  async acsPostPamsFixAssignCreateApplyDevice ({commit, state}) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixAssignUrl}/create/apply/device`, state.policiesApplicationAssign, { loading: false, successAlert: false })
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      else commit('mutPoliciesApplicationFirewall', res.result)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // PUT /api/pm/pams-fix/assign/create/apply/req/priv 정책 적용 마법사 - 정책 적용 > 이전 48p, 50p
  async acsPutPamsFixAssignCreateApplyReqPriv ({commit, state}) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/create/apply/req/priv`, state.policiesApplicationAssign, { loading: true, successAlert: false })
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 적용 마법사 - 정책 적용 > 취소 PUT /api/pm/pams-fix/assign/create/apply/req/cancel
  async acsPutPamsFixAssignCreateApplyCancel ({commit, dispatch, state}) {
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsFixAssignUrl}/create/apply/req/cancel`, state.policiesApplicationAssign, {loading: true, successAlert: false})
      if (res.code !== 'ok') commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 적용 마법사 - 정책 생성/최적화 > 적용 48p, 50p, 54p
  async acsPoliciesApplicationApply ({commit, state}) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixAssignUrl}/create/apply/complete`, state.policiesApplicationAssign)
      if (res.code === 'ok') commit('mutPoliciesApplicationApply', res)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // pams신청 정책 방화벽 적용 적책 위치 지정 조회
  async acsPamsFixAssignCreateApplayDeviceSeq ({commit, state}, payload) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.pamsFixAssignUrl}/create/apply/device/seq/${payload.pams_req_id}/${payload.device_id}`)
      if (res.code === 'ok') commit('mutPoliciesApplicationFirewallPosList', res.result)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // pams 신청 정책 방화벽 적용 정책 위치 지정(위치 디동 적용)
  async acsPostPoliciesApplicationFirewallPosition ({commit, state}, payload) {
    const result = {error: null}
    try {
      const req = _.clone(payload)
      delete payload.org_seq
      const res = await this.$axios.$post(`${state.apiUrl.pamsFixAssignUrl}/firewall/seq`, payload)
      if (res.code === 'ok') {
        res.source = req
        commit('mutPostPoliciesApplicationFirewallPosition', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 최적화정책 (신청정책)
  async acsPoliciesApplicationRuleList ({commit, state}, payload) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.pamsFixAssignUrl}/rule/fix/${payload.pams_req_id}/${payload.device_id}`)
      if (res.code === 'ok') commit('acsPoliciesApplicationRuleList', res.result)
      else commit('mutationErrorMessage', res.result.msg)
    } catch (error) { commit('mutationErrorMessage', error) }
  },
  // 정책 적용 마법사 > 상세보기 팝업(상세 신청 정보) > 생성 정책 정보 (대상 방화벽별 정책 조회)
  async acsPoliciesApplicationOptimization ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      commit('clearPoliciesOptimizationList')
      res = await this.$axios.$get(`${state.apiUrl.pamsFixAssignUrl}/rule/optimize/${payload.pams_req_id}/${payload.device_id}`, {loading: true, successAlert: false})
      if (res.code === 'ok') commit('acsPoliciesApplicationOptimization', res.result)
      else commit('mutationErrorMessage', res.result.msg)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // Savepoint
  async acsPamsSavePoint ({commit, state}, payload) {
    let res = {code: 'ok', result: {}}
    try {
      res = await this.$axios.$put(`${state.apiUrl.pamsSaveRollback}/${payload}`, null, {loading: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // Rollback
  async acsPamsRollback ({commit, state}, payload) {
    let res = {code: 'ok', result: {}}
    try {
      res = await this.$axios.$delete(`${state.apiUrl.pamsSaveRollback}/${payload}`, {loading: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  async fetchAppFilter ({commit, state}, payload = false) {
    const res = await this.$axios.$get(state.apiUrl.appObjUrl, {data: {}})
    if (res.code === 'ok') {
      commit('setAppFilter', {data: res.result, resetFlag: payload})
      return true
    } else {
      commit('setAppFilter', [])
      return {error: _.get(res, 'reason')}
    }
  }
}
export const getters = {
  selectedAppIdGetter (state) {
    return (!_.isEmpty(state.appFilterDataSet)) ? state.appFilterDataSet.map(item => _.get(item, 'app_obj_id')) : []
  },
  selectedAppLabelGetter (state) {
    const length = _.size(state.appFilterDataSet)
    let label = ''
    const firstApp = _.get(state.appFilterDataSet[0], 'app_obj_name')
    if (length > 0 && firstApp) {
      if (length === 1) label = firstApp
      else label = `${firstApp} ${i18n.t('cmn.other')} ${String(length - 1)}`
    }
    return label
  }
}
export const strict = false
